// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-card[data-v-0b0ca9f0]{padding:80px 0}@media(min-width: 1200px){.section-card .container[data-v-0b0ca9f0]{padding-left:0;padding-right:0}}@media(max-width: 1199.98px){.section>.container[data-v-0b0ca9f0]{padding-left:0;padding-right:0;max-width:100%}.section-card[data-v-0b0ca9f0]{border-radius:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
